import { ScreenWrapper } from '../../../../../../atoms/ScreenWrapper/ScreenWrapper';
import { styled } from '../../../../../../../core/theme/styled';

export const TintedScreenWrapper = styled(ScreenWrapper)`
  background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
`;

export const StyledCenterContainer = styled.div`
  text-align: center;
  width: 80%;
  margin: 0 auto;
`;

export const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: ${(props) => props.theme.sizes.xxxlarge};
`;
